import { ref } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { useUserStore } from "./user.store";
import { PaymentService, type PostApiPaymentHistoryResponse, type GetApiPaymentStatusResponse, type PaymentHistoryDto, type PostApiPaymentCreateResponse, type PostApiPaymentUpdatepaymentmethodResponse, type PostApiPaymentCreateinvoiceResponse, type GetApiPaymentInvoiceResponse, OpenAPI } from "@/client/";
import axios from "axios";
import saveAs from "file-saver";

export const usePaymentStore = defineStore("payment", () => {
  const page = ref(0);
  const pageSize = ref(20);
  const totalPages = ref(0);
  const history = ref<PaymentHistoryDto[]>();
  const userStore = useUserStore();
  const {auth} = storeToRefs(userStore);

  async function createSession(id :string) {
    return await PaymentService.postApiPaymentCreate({requestBody: {subscriptionTypeId: id}})
      .then(async (x: PostApiPaymentCreateResponse) => {
        return Promise.resolve(x.clientSecret!);
      })
      .catch((error: any) => {
        return Promise.reject("");
      });
  } 

  async function updatePaymentMethodSession() : Promise<any> {
    return await PaymentService.postApiPaymentUpdatepaymentmethod()
      .then(async (x: PostApiPaymentUpdatepaymentmethodResponse) => {
        return Promise.resolve(x);
      })
      .catch((error: any) => {
        return Promise.reject("");
      });
  } 

  async function sessionStatus(id :string) {
    return await PaymentService.getApiPaymentStatus({id: id})
      .then(async (x: GetApiPaymentStatusResponse) => {
        return Promise.resolve(x.status);
      })
      .catch((error: any) => {
        return Promise.reject("");
      });
  } 

  async function getPaymentHistory() {
      return await PaymentService.postApiPaymentHistory({ requestBody: { page: page.value, pageSize: pageSize.value } })
      .then(async (x: PostApiPaymentHistoryResponse) => {
        history.value = x.items;
        totalPages.value = x.totalPages || 0;
        return Promise.resolve(x);
      })
      .catch((error: any) => {
        return Promise.reject("");
      });
  }

  async function createInvoice(addr1:string, city:string, county:string, country:string, postcode:string, company:string, email:string, until: number, subTypeId:string) {
    return await PaymentService.postApiPaymentCreateinvoice({
      requestBody: {
        addressLine1: addr1,
        addressCity: city,
        addressCountry: country,
        addressCounty: county,
        addressPostcode: postcode,
        customerEmail: email,
        customerName: company,
        daysUntilDue: until,
        subscriptionTypeId: subTypeId
      }
    })
      .then(async (x: PostApiPaymentCreateinvoiceResponse) => {
        return Promise.resolve(x);
      })
      .catch((error: any) => {
        return Promise.reject("");
      });
  } 

  async function updatePayment() {
      return await PaymentService.postApiPaymentUpdatepaymentmethod()
      .then(async (x: PostApiPaymentUpdatepaymentmethodResponse) => {
        return Promise.resolve(x);
      })
      .catch((error: any) => {
        return Promise.reject("");
      });
  }

  async function getInvoice(invoiceId:string, filename:string) {
    await axios.request({
      baseURL: OpenAPI.BASE,
      method: "GET",
      responseType: "blob",
      url: "/api/payment/invoice",
      params: {
        id: invoiceId,
      },
      headers: {
        "Authorization": `Bearer ${auth.value?.token}`,
      }
    }).then(async (response: any) => {
      if (response == null) return;
      saveAs(response.data, filename);
    })
      .catch((error: any) => {
        return Promise.reject(error);
      })
      return await PaymentService.getApiPaymentInvoice({id:invoiceId})
      .then(async (x: GetApiPaymentInvoiceResponse) => {
        return Promise.resolve(x);
      })
      .catch((error: any) => {
        return Promise.reject("");
      });
  }


  return {
    createSession,
    getPaymentHistory,
    updatePaymentMethodSession,
    sessionStatus,
    createInvoice,
    updatePayment,
    getInvoice,
    history,
    page,
    totalPages,
    pageSize
  };
});
